// liveStreamConstants.js
'use strict';

export const STATUS_ONLINE = 'online';
export const STATUS_OFFLINE = 'offline';

export const PRESET_PREVIEW = 'preview';
export const PRESET_SD = 'sd';

export const LIVESTREAM_PATH = 'livestream';

export const CHARGE_PERIOD_SECONDS = 60;
// TODO: change to LEAD_CHARGE_SECONDS
export const PRECHARGE_SECONDS = 5;
export const PAYMENT_CHECK_INTERVAL_SECONDS = 1;
export const TEMPORARY_LEAVE_SECONDS = 180;

export const CHAT_QUEUE_LIMITATION = 5;
export const CHAT_DEBOUNCE_SECONDS = 1;
export const PREVIOUS_CHATS_LIMITATION = 2;
export const PINNED_MESSAGE_LIMITATION = 50;

export const SHOW_LIVE_STREAM_AD_THRESHOLD = 3;

export const TOP_LEADERBOARD_USER_LEAST = 3;
export const GIFT_LEADERBOARD_USER_LEAST = 15;
export const GOAL_BREAKDOWN_MINIMUM_USER_AMOUNT = 15;

export const RANGE_SESSION = 'session';
export const RANGE_24H = '1';
export const RANGE_7D = '7';
export const RANGE_30D = '30';

export const ASIDE_WIDTH = 360;

export const GIFT_LEADERBOARD_MOUNT_ELEMENT_ID =
  'livestream-leaderboard-mount-element';

export const DESKTOP_TRIGGER_PRIVATE_BUTTON_MOUNT_ID =
  'trigger-private-button-livestream-detail-online-footer-desktop';

// Shared by pushLivestreamNotification and the ModalView hosting the modal.
export const LIVESTREAM_NOTIFICATION_MODAL_ID = 'LivestreamNotificationModal';

export const ENTRY_TICKET_MODAL_ID = 'EntryTicketModal';
export const CROWDFUNDING_MODAL_ID = 'CrowdfundingModal';
export const TICKET_SOLD_OUT_MODAL_ID = 'TicketSoldOutModal';
export const CONFIRM_BUY_ENTRY_TICKET_MODAL_ID = 'ConfirmBuyEntryTicketModal';
export const CONFIRM_BUY_GOAL_TICKET_MODAL_ID = 'ConfirmBuyGoalTicketModal';
export const BUY_SPONSOR_TICKET_MODAL_ID = 'BuySponsorTicketModal';
export const CROWDFUNDING_BUTTON_MOUNT_ID =
  'crowdfunding-button-livestream-detail-online-header';

// Display order for top 3 users: [2nd, 1st, 3rd] (left to right, podium style)
export const TOP_USER_DISPLAY_ORDER = [2, 1, 3];

export const liveStreamChatType = {
  GIFT: 'gift',
  KARAOKE: 'karaoke',
  USER_ENTERED: 'userEntered',
  CHAT: 'chat',
  TOY_DEVICE: 'toyDevice',
  RATING: 'rating',
  CROWDFUNDING_TICKET: 'crowdfundingTicket',
};

export const LivestreamGiftType = {
  GIFT: 'gift',
  KARAOKE: 'karaoke',
};

export const CrowdfundingContributionType = {
  TICKET: 'ticket',
  DONATE: 'donate',
  BUYOUT: 'buyout',
};

// Values are sent verbatim as the `reason` API field and tracking property.
export const RatingFeedbackReasonType = {
  CONTENT_MISMATCH: 'content-mismatch',
  CREATOR_OFFSCREEN: 'creator-offscreen',
  LACK_INTERACTION: 'lack-interaction',
  OTHER: 'other',
};

export const LIVESTREAM_RATING_MODAL_IDS = [
  'LivestreamRatingHint',
  'LivestreamRatingModal',
  'LivestreamRatingFeedbackModal',
];

export const liveStreamSessionLeaderboardCategory = {
  GIFTS: 'gifts',
  VIEWS: 'views',
  TOTAL: 'total',
  ALL: 'all',
};

export const livestreamPaymentVia = {
  CLICK: 'click',
  AUTO: 'auto',
};

export const livestreamAdType = {
  SWAGGER: 'swagger',
  ADVERTISER: 'advertiser',
};

export const livestreamNoticeType = {
  USER_ENTERED_NOTICE: 'userEntered',
  SUPER_CHAT_NOTICE: 'superChatNotice',
  GIFT_NOTICE: 'giftNotice',
};

export const SESSION_DIAMOND_FIELD = {
  'total.diamonds.gifts': {
    title: 'info_stream_gift_revenue',
  },
  'total.diamonds.karaoke': {
    title: 'info_stream_command_revenue',
  },
  'total.diamonds.views': {
    title: 'info_private_stream_revenue',
  },
  'total.diamonds.show': {
    title: 'info_stream_show_revenue',
  },
  'total.diamonds.exclusive': {
    title: 'info_stream_exclusive_revenue',
  },
  'total.diamonds.chat': {
    title: 'super_chat',
  },
};

export const LivestreamProvider = {
  BYTEPLUS: 'byteplus',
  SWAG: 'swag',
  TENCENT: 'tencent',
  AGORA: 'agora',
};

export const GroupPrivateStatus = {
  DEFAULT: 'default',
  CONSIDERING: 'considering',
  COOLDOWN: 'cooldown',
  ACCEPTED: 'accepted',
};

export const ExclusivePrivateStatus = {
  DEFAULT: 'default',
  CONSIDERING: 'considering',
  COOLDOWN: 'cooldown',
  ACCEPTED: 'accepted',
  PREPARING: 'preparing',
  PERFORMING: 'performing',
};

export const VIEWER_CAMERA_PREPARING_LEAD_SECONDS = 10;
export const VIEWER_CAMERA_START_MODAL_ID = 'LivestreamViewerCameraStartModal';
export const VIEWER_CAMERA_MORE_MODAL_ID = 'LivestreamViewerCameraMoreModal';

export const LivestreamTriggerType = {
  TRIGGER_EXCLUSIVE: 'triggerExclusive',
  TRIGGER_PRIVATE: 'triggerPrivate',
};

export const EXCLUSIVE_PRIVATE_MINIMUM_MINUTES = 5;

export const INVITE_COUNTDOWN_SECONDS = 5;

export const PermissionMode = {
  CAMERA: 'camera',
  MICROPHONE: 'microphone',
  BOTH: 'both',
};

export const LivestreamTokenVia = {
  PAYMENT: 'payment',
  TOKEN_API: 'tokenApi',
};

export const LivestreamUIMode = {
  CLEAN: 0,
  NORMAL: 1,
};

export const LivestreamFetchTokenPurpose = {
  AGORA_RECURING: 'agora-recuring-token',
  PAID: 'paid-stream-token',
};

export const CommandProgressHintType = {
  COMMAND_SENT: 'sent',
  COMMAND_STARTING: 'starting',
};

export const StreamType = {
  NORMAL: 'normal',
  AUDIO: 'audio',
};

export const LIVESTREAM_CHANNEL_HEALTH_CHECK_INTERVAL_MSEC = 30000;
export const LIVESTREAM_CHANNEL_MAX_RESUBSCRIBE_ATTEMPTS = 10;
export const SIC_BO_CAMPAIGN_NAME = 'sic_bo';

// The single mode vocabulary for a livestream. Every value is the backend's own
// literal, so a reported mode can be compared against this table directly.
// `EXCLUSIVE` and `PRIVATE` are additionally produced front-end side, because
// the reported value alone cannot express the 1v1 sub-stages that only arrive
// as pusher events — see `getLivestreamComputedMode`.
export const LivestreamMode = {
  FREE: 'free',
  CROWDFUNDING_FUND_RAISING: 'crowdfundingFundRaising',
  CROWDFUNDING_PREPARE_PERFORMANCE: 'crowdfundingPreparePerformance',
  CROWDFUNDING_PERFORMING: 'crowdfundingPerforming',
  EXCLUSIVE: 'exclusive',
  PRIVATE: 'private',
};

// Where the crowdfunding state machine keeps its own status, beside `metadata`
// and never inside it: every snapshot replaces `[streamId, 'metadata']`
// wholesale, so anything stored under that node is gone on the next write (the
// same reason the viewer's own stake is a sibling too).
export const CROWDFUNDING_STATE_KEY = 'crowdfundingState';

// Where the viewer's own stake in the current round is kept, for the same
// reason as above.
export const CROWDFUNDING_ME_KEY = 'crowdfundingMe';

// The two modes where the funded performance is on the clock: the lead-in and
// the performance itself. Everything that treats "the show is happening" as one
// state checks against this pair.
export const PERFORMANCE_MODES = [
  LivestreamMode.CROWDFUNDING_PREPARE_PERFORMANCE,
  LivestreamMode.CROWDFUNDING_PERFORMING,
];

// Modes where the streamer has an ongoing crowdfunding round, funding included.
export const CROWDFUNDING_MODES = [
  LivestreamMode.CROWDFUNDING_FUND_RAISING,
  LivestreamMode.CROWDFUNDING_PREPARE_PERFORMANCE,
  LivestreamMode.CROWDFUNDING_PERFORMING,
];

// How a crowdfunding round reached its target.
export const CrowdfundingTriggerSource = {
  MANUAL: 'manual',
  AUTO: 'auto',
  USER_FULFILL: 'userFulfill',
};

// Which ticket a crowdfunding purchase was for; used as a tracking label.
export const CrowdfundingTicketType = {
  ENTRY: 'entry',
  GOAL: 'goal',
  SPONSOR: 'sponsor',
};

// The frame the goal reached animation is drawn into, and the aspect ratio the
// artwork was authored against.
export const CROWDFUNDING_PAG_REFERENCE_RATIO = 1080 / 1920;

// Which of the two plays is unknown until the goal is actually reached, so both
// are warmed while the round is still funding.
export const FUNDED_PAG = {
  filename: 'crowdfunding_funded.20260805.pag',
  ratio: 750 / 1624,
};
export const FUNDED_USER_FULFILL_PAG = {
  filename: 'crowdfunding_funded_user_fulfill.20260805.pag',
  ratio: CROWDFUNDING_PAG_REFERENCE_RATIO,
};

// Where the two live on the public CDN. The url is built at each call site so
// this file stays import free — 260 modules read it.
export const CROWDFUNDING_PAG_PATH = '/product-assets/livestream/';
